const MinusIcon = () => (
  <svg
    className="minus-icon"
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="#8E8E93"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.75"
      y="0.25"
      width="10.5"
      height="1.5"
      rx="0.75"
    />
  </svg>

)

export default MinusIcon
